import { ThemeProvider } from '@mui/material/styles';
import { createContext, useContext } from 'react';
import { useThemeMode } from './useThemeMode';

const ColorModeContext = createContext({
  toggleColorMode: () => { },
  mode: 'dark',
});

export const useThemeContext = () => {
  const colorMode = useContext(ColorModeContext);
  return colorMode;
};

export const ThemeContextProvider = ({ children }) => {
  const { theme, colorMode } = useThemeMode();
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
};
